import React from "react";
import { useNavigate } from "react-router-dom";
import "./horizonTable.css";

/**
 * Fatigue Management overview: entry point for work sheets, shift entry, and reports.
 * Process: Managers assign workers to sites → create work sheets → workers log shifts/breaks → rules checked → exceedance forms when triggered.
 */
function FatigueManagementPage() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Work Sheets",
      path: "/admin/fatigue/work-sheets",
      icon: "fa-solid fa-file-alt",
      description: "Create and manage work sheets linked to sites and workers. Shift and break data is saved against the assigned work sheet.",
    },
    {
      title: "Shift Entry",
      path: "/admin/fatigue/shifts",
      icon: "fa-solid fa-clock",
      description: "Log shift start/end times and breaks. Managers can enter or review shift details; workers log via app.",
    },
    {
      title: "Exceedance Forms",
      path: "/admin/fatigue/exceedance-forms",
      icon: "fa-solid fa-exclamation-triangle",
      description: "When rules are broken, a form is created. Employee fills first, then manager reviews. View and complete pending forms here.",
    },
    {
      title: "D-Fatigue Management Plan",
      path: "/admin/fatigue/d-fatigue-management-plan",
      icon: "fa-solid fa-file-signature",
      description: "Create, update, and manage SF-008-D fatigue management plans with full CRUD.",
    },
    {
      title: "Fatigue Rules List",
      path: "/admin/fatigue/fatigue-rules-list",
      icon: "fa-solid fa-chart-bar",
      description: "View fatigue exceedances, rule breaches, and breakdown by employee.",
    },
  ];

  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: "20px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        padding: "24px",
        marginBottom: "24px",
      }}
    >
      <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#1a202c", marginBottom: "8px" }}>
        Fatigue Management
      </h2>
      <p style={{ color: "#718096", fontSize: "14px", marginBottom: "24px" }}>
        Assign workers to sites (via Sites), create work sheets, and review shift data. Rules (12h rest, 12h shift, 72h in 7 days, etc.) are checked automatically. When a rule is broken, an alert is shown and an exceedance form is created — the employee fills the form first, then the manager reviews. See <strong>Exceedance Forms</strong> for pending forms and alerts.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "20px",
        }}
      >
        {cards.map((card) => (
          <button
            key={card.path}
            type="button"
            onClick={() => navigate(card.path)}
            style={{
              textAlign: "left",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              background: "#fff",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#8b1634";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(139, 22, 52, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e2e8f0";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div style={{ fontSize: "28px", color: "#8b1634", marginBottom: "12px" }}>
              <i className={card.icon} />
            </div>
            <div style={{ fontWeight: "600", color: "#1a202c", marginBottom: "8px", fontSize: "16px" }}>
              {card.title}
            </div>
            <div style={{ color: "#718096", fontSize: "14px", lineHeight: 1.4 }}>{card.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default FatigueManagementPage;
